import { useFeatureFlags } from '@/hooks';
import type { ExperimentationFeatureFlagsEntityTypeV1 } from '@montugroup/data-collection';
import { useMemo } from 'react';
import { PMS_ANALYTICS_FLAGS } from '../constants';
import { getFeatureFlagsForAnalytics } from '../utils/getFeatureFlagsForAnalytics';

/**
 * Returns LaunchDarkly feature flags formatted for analytics,
 * filtered by PMS_ANALYTICS_FLAGS.
 *
 * @returns Array of feature flags for use in analytics context
 */

export const useAnalyticsFeatureFlags = (): ExperimentationFeatureFlagsEntityTypeV1['flags'] => {
  const { flags } = useFeatureFlags();

  return useMemo(() => getFeatureFlagsForAnalytics(flags, PMS_ANALYTICS_FLAGS), [flags]);
};
